import { NetworkActionPrefix, ActionType } from '../utils/constants';
import {
    SWOTAreaApi,
    SWOTSessionApi,
    SWOTSessionParticipantApi,
    SWOTTopicApi,
    SWOTTopicVoteBatchApi,
    SWOTTopicVoteApi,
    SWOTTopicCommentApi,
    SWOTInboxApi
} from 'for-straction-service-api';
import { networkAPIAction, entityLifecycleActionSet, nestedEntityLifecycleActionSet, doubleNestedEntityLifecycleActionSet, tripleNestedEntityLifecycleActionSet } from '../utils/actionCreatorsFactory';
import { isInternalID } from '../api/utils';

export const loadAllSWOTAreas = () => networkAPIAction(SWOTAreaApi, 'sWOTAreaLoadAllGet', NetworkActionPrefix.LOAD_ALL_SWOT_AREAS_PREFIX, {});


const swotSessionActionSet = entityLifecycleActionSet('SWOTSession', 'SWOT_SESSION', 'session', SWOTSessionApi, {
    loadAll: 'sWOTSessionLoadAllGet',
    load: 'sWOTSessionLoadGet',
    add: 'sWOTSessionAddPut',
    edit: 'sWOTSessionEditPut',
    delete: 'sWOTSessionDeleteGet',
    voidAll: true
}, true);
export const loadAllSWOTSessions = ({ maxVoteBatchesCount, maxCommentsCount } = {}) =>
    swotSessionActionSet.loadAllSWOTSessions({ maxVoteBatchesCount, maxCommentsCount });
export const loadSWOTSession = (sessionID, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    swotSessionActionSet.loadSWOTSession(sessionID, { maxVoteBatchesCount, maxCommentsCount });
export const addSWOTSession = (session, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    swotSessionActionSet.addSWOTSession(session, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {});
export const editSWOTSession = (session, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    swotSessionActionSet.editSWOTSession(session, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {});
export const syncSWOTSession = (session) => swotSessionActionSet.syncSWOTSession(session);
export const startSWOTVoteBatch = (sessionID) => dispatch =>
    dispatch(networkAPIAction(SWOTSessionApi, 'sWOTSessionStartVoteBatchGet', NetworkActionPrefix.START_SWOT_VOTE_BATCH_PREFIX, { sessionID }, sessionID))
        .then(() => dispatch(loadSWOTSession(sessionID, { maxVoteBatchesCount: 2 })));
export const closeSWOTVoteBatch = (sessionID) =>
    networkAPIAction(SWOTSessionApi, 'sWOTSessionCloseVoteBatchGet', NetworkActionPrefix.CLOSE_SWOT_VOTE_BATCH_PREFIX, { sessionID }, sessionID);
export const removeSWOTSession = (sessionID) => swotSessionActionSet.removeSWOTSession(sessionID);
export const voidAllSWOTSessions = () => swotSessionActionSet.voidAllSWOTSessions();


const swotParticipantActionSet = nestedEntityLifecycleActionSet('SWOTParticipant', 'SWOT_PARTICIPANT', 'session', 'participant', SWOTSessionParticipantApi, {
    add: 'sWOTSessionParticipantAddPut',
    delete: 'sWOTSessionParticipantDeleteGet'
}, true);
export const addSWOTParticipant = (sessionID, participant, sync, reloadAfterSync) => swotParticipantActionSet.addSWOTParticipant(sessionID, participant, sync, reloadAfterSync);
export const syncSWOTParticipant = (sessionID, participant) => swotParticipantActionSet.syncSWOTParticipant(sessionID, participant);
export const removeSWOTParticipant = (sessionID, participantID) => swotParticipantActionSet.removeSWOTParticipant(sessionID, participantID);


const swotTopicActionSet = nestedEntityLifecycleActionSet('SWOTTopic', 'SWOT_TOPIC', 'session', 'topic', SWOTTopicApi, {
    load: 'sWOTTopicLoadGet',
    add: 'sWOTTopicAddPut',
    edit: 'sWOTTopicEditPut',
    delete: 'sWOTTopicDeleteGet',
    voidAll: true
}, true);
export const loadAllSWOTTopics = (sessionID, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    networkAPIAction(SWOTTopicApi, 'sWOTTopicSearchPut', NetworkActionPrefix.LOAD_ALL_SWOT_TOPICS_PREFIX,
        { sessionID }, { SessionID: sessionID }, { maxVoteBatchesCount, maxCommentsCount });
export const loadSWOTTopic = (sessionID, topicID, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    swotTopicActionSet.loadSWOTTopic(sessionID, topicID, { maxVoteBatchesCount, maxCommentsCount });
export const addAllSWOTTopics = (sessionID, topics, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.ADD_ALL_SWOT_TOPICS, sessionID, topics });

        if (!sync) {
            resolve();
        }
        else if (!reloadAfterSync) {
            dispatch(networkAPIAction(SWOTTopicApi, 'sWOTTopicAddAllPut', NetworkActionPrefix.ADD_ALL_SWOT_TOPICS_PREFIX, { sessionID, topics }, topics))
                .then(resolve, reject);
        } else {
            dispatch(networkAPIAction(SWOTTopicApi, 'sWOTTopicAddAllPut', NetworkActionPrefix.ADD_ALL_SWOT_TOPICS_PREFIX, { sessionID, topics }, topics))
                .then(() => dispatch(loadAllSWOTTopics(sessionID, { maxVoteBatchesCount, maxCommentsCount })))
                .then(resolve, reject);
        }
    });
export const addSWOTTopic = (sessionID, topic, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    swotTopicActionSet.addSWOTTopic(sessionID, topic, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount });
export const editAllSWOTTopics = (sessionID, topics, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    dispatch => new Promise((resolve, reject) => {
        dispatch({ type: ActionType.EDIT_ALL_SWOT_TOPICS, sessionID, topics });

        if (!sync) {
            resolve();
        }
        else if (!reloadAfterSync) {
            dispatch(networkAPIAction(SWOTTopicApi, 'sWOTTopicEditAllPut', NetworkActionPrefix.EDIT_ALL_SWOT_TOPICS_PREFIX, { sessionID, topics }, topics))
                .then(resolve, reject);
        } else {
            dispatch(networkAPIAction(SWOTTopicApi, 'sWOTTopicEditAllPut', NetworkActionPrefix.EDIT_ALL_SWOT_TOPICS_PREFIX, { sessionID, topics }, topics))
                .then(() => dispatch(loadAllSWOTTopics(sessionID, { maxVoteBatchesCount, maxCommentsCount })))
                .then(resolve, reject);
        }
    });
export const editSWOTTopic = (sessionID, topic, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount } = {}) =>
    swotTopicActionSet.editSWOTTopic(sessionID, topic, sync, reloadAfterSync, { maxVoteBatchesCount, maxCommentsCount });
export const syncSWOTTopic = (sessionID, topic) => swotTopicActionSet.syncSWOTTopic(sessionID, topic);
export const removeSWOTTopic = (sessionID, topicID) => swotTopicActionSet.removeSWOTTopic(sessionID, topicID);
export const voidAllSWOTTopics = (sessionID) => swotTopicActionSet.voidAllSWOTTopics(sessionID);


export const loadSWOTVoteBatchesSlice = (sessionID, topicID, { startID, maxCount, order } = {}) =>
    networkAPIAction(SWOTTopicVoteBatchApi, 'sWOTTopicVoteBatchSearchSlicePut', NetworkActionPrefix.LOAD_SWOT_VOTE_BATCHES_SLICE_PREFIX,
        { sessionID, topicID, reset: !startID }, { TopicID: topicID }, { startID, maxCount, order });

export const voidAllSWOTVoteBatches = (sessionID, topicID) => ({ type: ActionType.VOID_ALL_SWOT_VOTE_BATCHES, sessionID, topicID });


const swotVoteActionSet = tripleNestedEntityLifecycleActionSet('SWOTVote', 'SWOT_VOTE', 'session', 'topic', 'batch', 'vote', SWOTTopicVoteApi, { edit: 'sWOTTopicVoteEditPut' }, true);
export const editSWOTVotes = (sessionID, votes, sync) => dispatch => new Promise((resolve, reject) => {
    dispatch({
        type: ActionType.EDIT_SWOT_VOTES,
        sessionID,
        votes
    });
    if (!sync) {
        resolve();
    }
    else {
        dispatch(networkAPIAction(SWOTTopicVoteApi, 'sWOTTopicVoteEditAllPut', NetworkActionPrefix.EDIT_SWOT_VOTES_PREFIX, { sessionID, votes }, votes))
            .then(resolve, reject);
    }
});
export const editSWOTVote = (sessionID, topicID, batchID, vote, sync) => swotVoteActionSet.editSWOTVote(sessionID, topicID, batchID, vote, sync);

const swotCommentActionSet = doubleNestedEntityLifecycleActionSet('SWOTComment', 'SWOT_COMMENT', 'session', 'topic', 'comment', SWOTTopicCommentApi, {
    load: 'sWOTTopicCommentLoadGet',
    add: 'sWOTTopicCommentAddPut',
    voidAll: true
}, true);
export const loadSWOTCommentsSlice = (sessionID, topicID, { startID, maxCount, order } = {}) =>
    networkAPIAction(SWOTTopicCommentApi, 'sWOTTopicCommentSearchSlicePut', NetworkActionPrefix.LOAD_SWOT_COMMENTS_SLICE_PREFIX,
        { sessionID, topicID }, { TopicID: topicID }, { startID, maxCount, order });
export const loadSWOTComment = (sessionID, topicID, commentID) => swotCommentActionSet.loadSWOTComment(sessionID, topicID, commentID);
export const addSWOTComment = (sessionID, topicID, comment, sync, reloadAfterSync) => swotCommentActionSet.addSWOTComment(sessionID, topicID, comment, sync, reloadAfterSync);
export const voidAllSWOTComments = (sessionID, topicID) => swotCommentActionSet.voidAllSWOTComments(sessionID, topicID);

const swotInboxActionSet = entityLifecycleActionSet('SWOTInbox', 'SWOT_INBOX', 'sWOTInbox', SWOTInboxApi, {
    loadAll: true,
    load: true,
    add: true,
    delete: true,
    edit: true
});
export const loadAllSWOTInboxs = () => swotInboxActionSet.loadAllSWOTInboxs();
export const loadSWOTInbox = () => swotInboxActionSet.loadSWOTInbox();
export const addSWOTInbox = (sWOTInbox, sync, reloadAfterSync) => swotInboxActionSet.addSWOTInbox(sWOTInbox, sync, reloadAfterSync);
export const editSWOTInbox = (sWOTInbox, sync) => swotInboxActionSet.editSWOTInbox(sWOTInbox, sync);
export const removeSWOTInbox = (swotInboxID) => swotInboxActionSet.removeSWOTInbox(swotInboxID);
export const syncSWOTInbox = (sWOTInbox) => swotInboxActionSet.syncSWOTInbox(sWOTInbox);

export const sendInsightFeedback = (swotInboxID, comment) =>
    networkAPIAction(SWOTInboxApi, 'sWOTInboxSendFeedbackGet', NetworkActionPrefix.SEND_INSIGHT_FEEDBACK_PREFIX, {}, swotInboxID, comment);